<script lang="ts" setup>
import { tpgIconArrowDown } from '@tpg/grammar-web-icons';
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { GrammarPrimaryButton } from '@nora-monorepo/grammar-ui';

import type { ShowNewContentButtonState } from '#nora-chat-ui/stores/scroll-store';
import { useScrollStore } from '#nora-chat-ui/stores/scroll-store';

interface ScrollToNewContentButtonProps {
  conversationId: string;
}

const props = defineProps<ScrollToNewContentButtonProps>();
const { t } = useI18n();
const scrollStore = useScrollStore();

const showNewContentButton = ref(true);
const newContentCount = ref(0);

watch(
  () =>
    scrollStore.getShowNewContentStateForConversationId(props.conversationId),
  (state?: ShowNewContentButtonState) => {
    if (typeof state === 'undefined') {
      showNewContentButton.value = false;

      return;
    }

    showNewContentButton.value = state.showNewContentButton;
    newContentCount.value = state.newContentCount;
  },
  {
    immediate: true,
  },
);

function scroll() {
  scrollStore.scrollConversationToBottom(props.conversationId, true);
}
</script>

<template>
  <div class="relative h-0">
    <GrammarPrimaryButton
      v-if="showNewContentButton"
      class="absolute left-[50%] translate-x-[-50%] bottom-16 z-10"
      :label="newContentCount > 0 ? t('conversation.newActivity') : ''"
      :icon-template="tpgIconArrowDown"
      :icon-position="newContentCount > 0 ? 'trailing' : 'leading'"
      @click="scroll"
    />
  </div>
</template>
